import { Inject, Injectable, Optional } from '@angular/core';
import { HttpParamsObject } from '../../services/api/api.service';
import { FhirApiService } from '../../services/api/fhir-api.sevice';
import { UserService } from '../../services/user.service';
import { ProviderSearchParams } from './base-provider.model';
import { BaseProvidersService } from './base-providers.service';
import {
  PractitionerProvider,
  PractitionerProviderAdapter,
} from './practitioner-provider.model';
import { ReducerManager, Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class PractitionerProvidersService extends BaseProvidersService<PractitionerProvider> {
  get defaultParamsObject(): HttpParamsObject {
    return {
      // 'organization.subject-group': this.partnerCode,
      // 'practitioner.subject-group': this.partnerCode,
      // _count: '1000',
      // _getpageoffset: '1000',
      _include: '*',
      // 'practitioner.active': 'true',
    };
  }

  constructor(
    @Inject('dataName') @Optional() dataName: string,
    protected adapter: PractitionerProviderAdapter,
    protected fhirApi: FhirApiService,
    protected userService: UserService,
    protected store: Store,
    protected manager: ReducerManager,
  ) {
    super(
      dataName || 'practitoner-providers',
      adapter,
      fhirApi,
      userService,
      store,
      manager,
    );
  }

  processProviderSearchParams(params: ProviderSearchParams): HttpParamsObject {
    const paramsObject = {};

    if (params.firstName)
      paramsObject['practitioner.given:contains'] = params.firstName;
    if (params.lastName)
      paramsObject['practitioner.family:contains'] = params.lastName;
    if (params.zip)
      paramsObject['organization.address-postalcode'] = params.zip;
    if (params.city) paramsObject['organization.address-city'] = params.city;

    if (params.street || params.house)
      paramsObject['organization.address-line:contains'] = [
        params.street,
        params.house,
      ]
        .filter((x) => x)
        .join(' ');

    if (params.facilityType)
      paramsObject['practitioner.type'] = params.facilityType;
    if (params.specialty)
      paramsObject['practitioner.specialty'] = params.specialty;

    if (params.mandantId)
      paramsObject[
        'organization.subject-system'
      ] = `urn:oid:${params.mandantId}|`;

    if (params.ids) {
      const _id = Array.isArray(params.ids) ? params.ids.join(',') : params.ids;
      paramsObject['_id'] = _id;
    }

    if (params._count) {
      paramsObject['_count'] = params._count;
    }
    if (params._getpageoffset) {
      paramsObject['_getpageoffset'] = params._getpageoffset;
    }
    if (params['organization.active']) {
      paramsObject['organization.active'] = params['organization.active'];
    }

    if (params['practitioner.active']) {
      paramsObject['practitioner.active'] = params['practitioner.active'];
    }
    if (params['organization.subject-group']) {
      paramsObject['organization.subject-group'] =
        params['organization.subject-group'];
    }
    if (params['practitioner.subject-group']) {
      paramsObject['practitioner.subject-group'] =
        params['practitioner.subject-group'];
    }

    return paramsObject;
  }
}
